// Quiz questions for the diagnostic
export const quizQuestions = [
  {
    id: 1,
    question: "Quel est votre niveau de connaissance de l'IA générative ?",
    options: [
      { value: "expert", label: "Expert - J'utilise déjà des outils IA au quotidien", score: 10 },
      { value: "intermediate", label: "Intermédiaire - J'ai testé quelques outils", score: 7 },
      { value: "beginner", label: "Débutant - Je connais le concept mais pas la pratique", score: 4 },
      { value: "none", label: "Novice - Je découvre le sujet", score: 1 },
    ],
  },
  {
    id: 2,
    question: "Combien de temps passez-vous sur des tâches répétitives chaque semaine ?",
    options: [
      { value: "more20", label: "Plus de 20 heures", score: 10 },
      { value: "10to20", label: "Entre 10 et 20 heures", score: 8 },
      { value: "5to10", label: "Entre 5 et 10 heures", score: 5 },
      { value: "less5", label: "Moins de 5 heures", score: 2 },
    ],
  },
  {
    id: 3,
    question: "Utilisez-vous déjà des outils numériques pour votre activité ?",
    options: [
      { value: "advanced", label: "Oui, plusieurs outils intégrés (CRM, ERP, etc.)", score: 10 },
      { value: "some", label: "Oui, quelques outils basiques", score: 7 },
      { value: "minimal", label: "Juste email et tableur", score: 4 },
      { value: "none", label: "Très peu d'outils numériques", score: 1 },
    ],
  },
  {
    id: 4,
    question: "Quel est votre principal défi actuel ?",
    options: [
      { value: "time", label: "Manque de temps pour les tâches à forte valeur", score: 10 },
      { value: "costs", label: "Besoin de réduire les coûts opérationnels", score: 8 },
      { value: "growth", label: "Difficultés à développer mon activité", score: 7 },
      { value: "quality", label: "Améliorer la qualité de service", score: 6 },
    ],
  },
  {
    id: 5,
    question: "Avez-vous une équipe qui pourrait être formée à l'IA ?",
    options: [
      { value: "team10", label: "Oui, plus de 10 personnes", score: 10 },
      { value: "team5", label: "Oui, entre 5 et 10 personnes", score: 8 },
      { value: "team2", label: "Oui, 2 à 5 personnes", score: 6 },
      { value: "solo", label: "Je suis seul(e) ou avec 1 collaborateur", score: 4 },
    ],
  },
  {
    id: 6,
    question: "Quel budget êtes-vous prêt à investir dans la transformation digitale ?",
    options: [
      { value: "high", label: "Plus de 10 000€", score: 10 },
      { value: "medium", label: "Entre 5 000€ et 10 000€", score: 8 },
      { value: "low", label: "Entre 1 000€ et 5 000€", score: 5 },
      { value: "minimal", label: "Moins de 1 000€", score: 2 },
    ],
  },
  {
    id: 7,
    question: "À quelle échéance souhaitez-vous voir des résultats ?",
    options: [
      { value: "immediate", label: "Dans les 3 prochains mois", score: 10 },
      { value: "short", label: "Dans les 6 prochains mois", score: 8 },
      { value: "medium", label: "D'ici 1 an", score: 5 },
      { value: "long", label: "Pas de deadline précise", score: 2 },
    ],
  },
  {
    id: 8,
    question: "Quelle est votre principale source de revenus ?",
    options: [
      { value: "services", label: "Prestations de services", score: 9 },
      { value: "products", label: "Vente de produits", score: 8 },
      { value: "both", label: "Mix produits et services", score: 10 },
      { value: "other", label: "Autre", score: 5 },
    ],
  },
  {
    id: 9,
    question: "Comment gérez-vous actuellement votre relation client ?",
    options: [
      { value: "crm", label: "Avec un CRM professionnel", score: 10 },
      { value: "spreadsheet", label: "Avec des fichiers Excel/Sheets", score: 6 },
      { value: "email", label: "Par email uniquement", score: 4 },
      { value: "manual", label: "Carnet de notes / mémoire", score: 2 },
    ],
  },
  {
    id: 10,
    question: "Êtes-vous prêt à investir du temps dans la formation ?",
    options: [
      { value: "dedicated", label: "Oui, plusieurs jours dédiés", score: 10 },
      { value: "some", label: "Oui, quelques heures par semaine", score: 7 },
      { value: "minimal", label: "Peu de temps disponible", score: 4 },
      { value: "none", label: "Pas de temps pour la formation", score: 1 },
    ],
  },
];

export default quizQuestions;
